export default "https://a.travel-assets.com/partner-portal/eg_logo.1341d71669d2.svg";